export const PATIENT_NAME_OPTIONS = {
  FullName: "Patient.FullName",
  FirstName: "Patient.FirstName",
  LastName: "Patient.LastName",
  PreferredName: "Patient.PreferredName",
  Title: "Patient.Title",
  Suffix: "Patient.Suffix",
  SunoId: "Patient.SunoId"
};
